import service from '@/store/services/fms/dashboard-service';

const state = {
  list: {},
  dashboard: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, dashboard) => {
    state.dashboard = dashboard;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};
 
const actions = {

  fakturNotaJasa({commit, dispatch}, params) {
    return service.fakturNotaJasa(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  fakturNotaPart({commit, dispatch}, params) {
    return service.fakturNotaPart(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  driverActive({commit, dispatch}, params) {
    return service.driverActive(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  vehicleTaxiActive({commit, dispatch}, params) {
    return service.vehicleTaxiActive(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  vehicleInOutPool({commit, dispatch}, params) {
    return service.vehicleInOutPool(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  vehicleInService({commit, dispatch}, params) {
    return service.vehicleInService(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },

  spjPaidunpaid({commit, dispatch}, params) {
    return service.spjPaidunpaid(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },


  traceHold({commit, dispatch}, params) {
    return service.traceHold(params)
      .then((dashboard) => { commit('SET_RESOURCE', dashboard); });
  },


  // destroy({commit, dispatch}, params) {
  //   return service.destroy(params);
  // }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total, 
  dashboard: state => state.dashboard,
};
 
const dashboard = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default dashboard;
